import React from 'react';
import PropTypes from 'prop-types';
import ButtonBack from 'components/button/ButtonBack';
import ButtonSave from 'components/button/ButtonSave';



const EditFormFooter = ({ onBackClick, onSubmitClick }) => {   
    return (
        <div className="grid collapse840">
        <div className="col s1of2">
            <ButtonBack text="Til baka" onClick={onBackClick} />
          </div>
          <div className="col s1of2 float-right text-right">
            <ButtonSave text="Vista" onClick={onSubmitClick}/>
          </div>
      </div>      
      );
};

EditFormFooter.propTypes = {  
  onSaveClick : PropTypes.func,
  onBackClick : PropTypes.func
};

export default EditFormFooter;
